import { CardReaderTechType } from 'src/app/modules/settings/services/http/api-settings.service';
import { AdriaCardReaderSettings } from './adria-card-reader-settings.model';

export class CardStatus {
  status: number;
  typeId: number;
  type: string;
  tech: string;
  uid: string;
  isAdriaCard: boolean;
  adriaId?: string;

  constructor() {}

  public static cardReaderInfoIsValid(
    primaryCardOnReaderInfo: CardStatus,
    secondaryCardOnReaderInfo: CardStatus,
    dualCardSettings: AdriaCardReaderSettings
  ) {
    // Mifare uid length can be 4 or 7 bytes / 8 or 14 chars
    // RFID uid length is always 5 bytes / 10 chars

    if (dualCardSettings.mainType === CardReaderTechType.Mifare &&
      this.mifareCardStatusIsValid(primaryCardOnReaderInfo)
      && this.rfidCardStatusIsValid(secondaryCardOnReaderInfo)) {
      return true
    } else if (dualCardSettings.mainType === CardReaderTechType.Rfid
      && this.rfidCardStatusIsValid(primaryCardOnReaderInfo)
      && this.mifareCardStatusIsValid(secondaryCardOnReaderInfo) ) {
      return true
    }

    return false;
  }

  private static mifareCardStatusIsValid(cardStatus: CardStatus) {
    return cardStatus?.uid && cardStatus.uid.length !== 10
  }

  private static rfidCardStatusIsValid(cardStatus: CardStatus) {
    return cardStatus?.uid && cardStatus.uid.length === 10
  }



}
